import { type HTMLProps, type ReactNode } from 'react'

import { Icon, Layout, Text, Tooltip } from '@loadsmart/miranda-react'
import { type ColorToken } from '@loadsmart/miranda-react/dist/tokens'

export function SummaryLabel(
  props: Omit<HTMLProps<HTMLElement>, 'ref' | 'label' | 'value'> & {
    readonly inline?: boolean
    readonly label?: ReactNode
    readonly value?: ReactNode
    readonly tip?: ReactNode
    readonly color?: ColorToken
  }
) {
  const { inline, label, value, tip, color, ...rest } = props
  const Wrapper = inline ? Layout.Group : Layout.Stack

  return (
    <Wrapper {...rest} gap="spacing-2" align="baseline">
      {label != null && (
        <Layout.Group gap="spacing-1" align="flex-start">
          <Text variant="body-sm" color="color-text-tertiary">
            {label}&nbsp;
          </Text>
          {tip && (
            <>
              <Tooltip message={tip} trigger="hover" placement="right">
                <Icon
                  title="More information"
                  size="small"
                  name="question"
                  color="color-text-placeholder"
                />
              </Tooltip>
              &nbsp;
            </>
          )}
        </Layout.Group>
      )}
      <Text variant="body-md" color={color || 'color-text-primary'}>
        {value}
      </Text>
    </Wrapper>
  )
}
